import { Configuration } from '@azure/msal-browser';

import { AuthorizationSettings } from '../../../site-settings/models';
import { setMsalClient } from '../client';
import { B2cPolicy } from '../enums/b2c-policy.enum';
import { IMsalB2cPolicies } from '../models';

const UIP_BASE_API_CONFIG: Configuration = {
  auth: {
    clientId: '',
  },
};

export const getUipConfig = (): Configuration => {
  return UIP_BASE_API_CONFIG;
};

export const setUipConfig = async (config: Configuration) => {
  Object.assign(UIP_BASE_API_CONFIG, config);
  await setMsalClient();
};

/**
 * Build separate B2C Policies for sign-in and sign-up based on authorization settings
 * @param settings Authorization settings
 */
export const buildB2cPolicies = (settings: AuthorizationSettings): IMsalB2cPolicies => {
  const { uipAuthorityDomain, uipSignUpSignInPolicy, uipSignUpPolicy, uipTenantId } = settings;
  const signInPolicyName = uipSignUpSignInPolicy ? uipSignUpSignInPolicy : B2cPolicy.SignUpOrSignin;
  const signUpPolicyName = uipSignUpPolicy ? uipSignUpPolicy : B2cPolicy.SignUp;
  return {
    authorities: {
      signIn: {
        authority: `https://${uipAuthorityDomain}/${uipTenantId}/${uipSignUpSignInPolicy}`,
      },
      signUp: {
        authority: `https://${uipAuthorityDomain}/${uipTenantId}/${uipSignUpPolicy}`,
      },
    },
    names: {
      signIn: signInPolicyName,
      signUp: signUpPolicyName,
    },
  };
};
